import React from "react";
import { Link } from "react-router-dom";
const PostCard = ({ article }) => {
  return (
    <div className="flex shadow-md rounded-lg  gap-4 my-3 hover:bg-gray-200 bg-base-200">
      <div className="w-1/3 aspect-[3/2]">
        <img
          src={`${process.env.REACT_APP_API_URL}media/${article?.images[0]?.url}`}
          alt={article.title}
          className="rounded-md object-cover w-full h-full"
        />
      </div>
      <div className="w-2/3 flex flex-col justify-center ">
        <Link to={`/post/${article.slug}`}>
          <h2
            className="text-sm font-semibold mb-2 overflow-hidden text-ellipsis pl-2 pr-4"
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
            }}
          >
            {article.title}
          </h2>
        </Link>

        <p className="text-sm text-gray-600">{article.description}</p>
      </div>
    </div>
  );
};

export default PostCard;
